import { withTranslation } from 'react-i18next';
import { Col, Collapse, Row } from 'reactstrap';

import IndicatorsProps from '../../types/IndicatorsProps';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import Discounts from './Discounts';
import Card from '../Card';
import DiscountsInfo from './DiscountsInfo';
import { useState } from 'react';

const DiscountIndicators = (props: IndicatorsProps): React.JSX.Element => {
  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <div style={{ marginBottom: isOpen ? 50 : 0 }}>
      <BreadCrumb
        title={props?.t('reports.discount.heading')}
        onClick={toggle}
        description={props?.t(
          isOpen ? 'reports.click-to-hide' : 'reports.click-to-expand'
        )}
      />

      <Collapse isOpen={isOpen}>
        <Row>
          <Col>
            <Card body={<Discounts {...props} />} />
          </Col>

          <Col xl={4} lg={12}>
            <DiscountsInfo {...props} />
          </Col>
        </Row>
      </Collapse>
    </div>
  );
};

export default withTranslation()(DiscountIndicators);
